import { NEW_HUB_URL } from "./constants";

// Maps an old-hub route prefix to the closest Jem Hub 2.0 path. Keys are the
// ACTUAL old-hub routes (verified against the feature routers). deepLink picks
// the longest matching prefix, so more specific entries win regardless of order.
const ROUTE_MAP: ReadonlyArray<readonly [string, string]> = [
  ["/employees/tags", "/employees/tags-segments"],
  ["/employees", "/employees"],
  ["/payslips", "/documents"],
  ["/irp5s", "/documents"],
  ["/rosters", "/documents"],
  ["/timesheets", "/documents"],
  ["/secure-file-upload", "/documents"],
  ["/announcements", "/announcements"],
  ["/multimessaging", "/multimessaging"],
  ["/surveys", "/surveys"],
  ["/forms", "/surveys"],
  ["/query", "/inbox"],
  ["/employeeleave", "/leave"],
  ["/financial-benefits", "/financial-benefits"],
  ["/recons", "/recons"],
  ["/time-attendance", "/time-attendance"],
  ["/site-configuration", "/settings"],
  ["/settings", "/settings"],
  ["/tags", "/employees/tags-segments"],
];

// Segment-boundary match so "/employees" doesn't match "/employeeship" and
// "/tags" doesn't match "/tags-old".
const matchesPrefix = (path: string, prefix: string): boolean =>
  path === prefix || path.startsWith(`${prefix}/`);

export const deepLink = (oldPath: string): string => {
  const path = (oldPath || "/").split("?")[0];
  const match = ROUTE_MAP.filter(([prefix]) => matchesPrefix(path, prefix)).sort(
    (a, b) => b[0].length - a[0].length
  )[0];
  const newPath = match ? match[1] : "/";
  return `${NEW_HUB_URL}${newPath}`;
};
